export default __webpack_public_path__ + "static/media/peacekeepers.46d13f63.png";